import React from 'react';

function Trailer(props) {
	return (
		<div className="embed-responsive embed-responsive-16by9" id="video">
			<iframe width="560" height="315" src="https://www.youtube.com/embed/mK1DDqoV9sM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</div>
		)
}
export default Trailer;
